<template>
  <div>
    <el-table
      :data="records"
      border
      size="mini"
      v-loading="loading"
      element-loading-text="正在加载中～"
    >
      <el-table-column label="类型" prop="type" align="center" width="100" />
      <el-table-column label="发送时间" prop="createTime" align="center" />
      <el-table-column label="发送状态" prop="state" align="center" show-overflow-tooltip />
      <el-table-column label="手机号/openId/邮箱" prop="mobile" align="center" />
      <el-table-column label="信息标题" prop="title" align="center" />
      <el-table-column label="信息内容" prop="text" align="center">
        <template slot-scope="{ row }">
          <el-tooltip class="item" effect="dark" placement="top-start">
            <div class="tooltip-content" slot="content">{{ row.text }}</div>
            <div class="tooltip-trigger">{{ row.text }}</div>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <div style="display: flex; justify-content: right; margin-right: 20px; margin-top: 20px">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="paginationObj.current"
        :page-size="paginationObj.size"
        background
        layout="prev, pager, next"
        :total="total"
        size="mini"
      />
    </div>
  </div>
</template>

<script>
  import { userMessagePage } from '@/api'
  export default {
    props: {
      message: {
        type: Object,
        default: () => {}
      },
      mobile: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        records: [],
        total: 0,
        paginationObj: {
          current: 1,
          size: 5
        },
        loading: false,
        pkgViewVisible: false
      }
    },
    mounted() {
      this.records = this.message.records || []
      this.total = this.message.total || 0
    },
    methods: {
      handlePkgView(id) {
        this.pkgViewVisible = true
        this.$nextTick(() => {
          this.$refs.pkgView.init(id)
        })
      },
      closeLoading() {
        this.$loading().close()
      },
      previewInvoice(url) {
        location.href = url
      },
      async getPage() {
        this.loading = true
        const params = {
          ...this.paginationObj,
          mobile: this.mobile,
          state: this.state
        }
        const { code, data } = await userMessagePage(params)
        if (code === 0) {
          const { total, records } = data
          this.records = records
          this.total = total
          this.loading = false
        }
      },
      handleCurrentChange(e) {
        this.paginationObj.current = e
        this.getPage()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .tooltip-content {
    width: 250px;
  }
  .tooltip-trigger {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
</style>
